export const TEST_ID = 'activityTimeText';
